var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcStreaming = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.28 5.866a1 1 0 0 1 0 1.414 12.333 12.333 0 0 0 0 17.44 1 1 0 1 1-1.414 1.414 14.333 14.333 0 0 1 0-20.268 1 1 0 0 1 1.414 0m17.44 0a1 1 0 0 1 1.414 0 14.333 14.333 0 0 1 0 20.268 1 1 0 1 1-1.415-1.414 12.334 12.334 0 0 0 0-17.44 1 1 0 0 1 0-1.414m-13.666 3.76a1 1 0 0 1 0 1.415 7 7 0 0 0 0 9.905A1 1 0 0 1 9.64 22.36a9 9 0 0 1 0-12.735 1 1 0 0 1 1.414 0m9.892.014a1 1 0 0 1 1.414 0 9 9 0 0 1 0 12.734 1 1 0 0 1-1.413-1.415 7 7 0 0 0 0-9.905 1 1 0 0 1-.001-1.414",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 3
})));
export default SvgIcStreaming;